class SnowplowHelper
  spVersion: "2.14.0"
  avalancheTrackerName: "sb-ava"
  pvAvalancheTrackerName:  "sb-ava-pv"
  bronzeAvalancheTrackerName: "sb-ava-br"

  constructor: ({
    appId,
    cookieDomain,
    uid,
    avalancheCollector,
    includeGAContext,
    eventMethod,
    trackActivity,
    forceSecureTracker,
    postPath
  }) ->
    @_loadSnowplow(@spVersion) unless window.snowplow

    # Initialize trackers
    snowplow "newTracker", @bronzeAvalancheTrackerName, avalancheCollector,
      appId: appId, cookieDomain: cookieDomain,
      eventMethod: eventMethod,
      postPath: postPath,
      forceSecureTracker: forceSecureTracker

    snowplow "newTracker", @pvAvalancheTrackerName, avalancheCollector,
      appId: appId,
      cookieDomain: cookieDomain,
      postPath: postPath,
      eventMethod: if eventMethod == "post" then "beacon" else eventMethod,
      forceSecureTracker: forceSecureTracker,
      contexts:
        webPage: trackActivity
        gaCookies: includeGAContext


    snowplow "newTracker", @avalancheTrackerName, avalancheCollector,
      appId: appId, cookieDomain: cookieDomain
      eventMethod: eventMethod,
      postPath: postPath,
      forceSecureTracker: forceSecureTracker

    # Enable form auto tracking
    snowplow "enableFormTracking:#{@bronzeAvalancheTrackerName}",
      forms:
        whitelist: ["js-tracked"]
      fields:
        filter: (elt) -> !elt.disabled

    snowplow "setCookiePath", "/"
    snowplow "setUserId", uid if uid?

  trackPageView: (contexts, trackActivity = false) ->
    validated_contexts = null # snowplow expects null if there are no contexts

    for context of contexts
      validated_contexts = [] if validated_contexts == null
      validated_contexts.push contexts[context] if contexts[context]

    if trackActivity
      @enableActivityTrackingCallback(validated_contexts)

    snowplow "trackPageView:#{@pvAvalancheTrackerName}", null, validated_contexts

    return @

  enableActivityTrackingCallback: (validated_contexts) ->
    interval = 5

    aggregatedEvent =
      pageViewId: null,
      minXOffset: 0,
      maxXOffset: 0,
      minYOffset: 0,
      maxYOffset: 0,
      numEvents: 0

    snowplow "enableActivityTrackingCallback:#{@pvAvalancheTrackerName}", 1, interval, (e) ->
      aggregatedEvent =
        pageViewId: e.pageViewId,
        minXOffset: Math.min(aggregatedEvent.minXOffset, e.minXOffset),
        maxXOffset: Math.max(aggregatedEvent.maxXOffset, e.maxXOffset),
        minYOffset: Math.min(aggregatedEvent.minYOffset, e.minYOffset),
        maxYOffset: Math.max(aggregatedEvent.maxYOffset, e.maxYOffset),
        numEvents: aggregatedEvent.numEvents + 1
      return @

    window.addEventListener "unload", () ->
      data =
        schema: "iglu:com.simplybusiness/page_unloaded/jsonschema/1-0-0",
        data:
          pageViewId: aggregatedEvent.pageViewId,
          minXOffset: Math.max(0, Math.round(aggregatedEvent.minXOffset)),
          maxXOffset: Math.max(0, Math.round(aggregatedEvent.maxXOffset)),
          minYOffset: Math.max(0, Math.round(aggregatedEvent.minYOffset)),
          maxYOffset: Math.max(0, Math.round(aggregatedEvent.maxYOffset)),
          activeSeconds: aggregatedEvent.numEvents * interval

      if aggregatedEvent.pageViewId != null
        snowplow "trackSelfDescribingEvent", data, validated_contexts

      return @

    return @

  trackAdImpression: ({costModel, cost, targetUrl, bannerId, zoneId, advertiserId, campaignId}) ->
    impressionId = Math.random().toString(36).substring(2)

    snowplow "trackAdImpression:#{@avalancheTrackerName}",
      impressionId,
      costModel,
      cost,
      targetUrl,
      bannerId,
      zoneId,
      advertiserId,
      campaignId

    return @

  trackAdClick: ({targetUrl, clickId, costModel, cost, bannerId, zoneId, advertiserId, campaignId}) ->
    impressionId = Math.random().toString(36).substring(2)

    snowplow "trackAdClick:#{@avalancheTrackerName}",
      targetUrl,
      clickId,
      costModel,
      cost,
      bannerId,
      zoneId,
      impressionId,
      advertiserId,
      campaignId

    return @

  trackFrontofficeStructEvent: ({category, action, label, property, serviceChannelIdentifier, value}) ->
    throw new Error ("Missing service channel identifier in the trackFrontofficeStructEvent method") unless serviceChannelIdentifier

    context =
      [
        {
          schema: 'iglu:com.simplybusiness/distribution_channel_context/jsonschema/1-0-0'
          data:
            service_channel_identifier: serviceChannelIdentifier
        },
        {
          schema: 'iglu:com.simplybusiness/service_channel_context/jsonschema/1-0-0'
          data:
            service_channel_identifier: serviceChannelIdentifier
        }
      ]

    snowplow "trackStructEvent:#{@bronzeAvalancheTrackerName}",
      category,
      action,
      label,
      property,
      value,
      context
    return @

  trackBackofficeStructEvent: ({category, action, label, property, value}) ->
    snowplow "trackStructEvent:#{@bronzeAvalancheTrackerName}",
      category,
      action,
      label,
      property,
      value
    return @

  trackUnstructEvent: (schema, data, context = null) ->
    snowplow "trackUnstructEvent:#{@avalancheTrackerName}",
      schema: schema
      data: data,
      context
    return @

  trackLinkClick: ({targetUrl, elementId, elementClasses, elementTarget, elementContent, context, tstamp}) ->
    # This ensures the resulting href is absolute
    a = document.createElement("a")
    a.href = targetUrl
    targetUrl = a.href

    snowplow "trackLinkClick:#{@avalancheTrackerName}",
      targetUrl,
      elementId,
      elementClasses,
      elementTarget,
      elementContent?.replace(/^\s*(.*?)\s*$/, "$1"),
      context,
      tstamp

    return @

  serviceChannelContext: ({version, serviceChannelIdentifier}) ->
    [
      {
        schema: 'iglu:com.simplybusiness/service_channel_context/jsonschema/' + version,
        data: {
          service_channel_identifier: serviceChannelIdentifier
        }
      }
    ]


  distributionChannelContext: ({version, serviceChannelIdentifier}) ->
    [
      {
        schema: 'iglu:com.simplybusiness/distribution_channel_context/jsonschema/' + version,
        data: {
          service_channel_identifier: serviceChannelIdentifier
        }
      },
      {
        schema: 'iglu:com.simplybusiness/service_channel_context/jsonschema/' + version,
        data: {
          service_channel_identifier: serviceChannelIdentifier
        }
      }
    ]

# Loads the snowplow tracker script asynchronously
  # and sets up the snowplow queue
  _loadSnowplow: (version) ->
    `(function(p,l,o,w,i,n,g)
      {if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[];
        p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)
        };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;
        n.src=w;g.parentNode.insertBefore(n,g)}
        }(window,document,"script",
          "//d2rsg57kfr3nt3.cloudfront.net/sp-"+version+".js",
          "snowplow"
        )
     );`

module.exports.SnowplowHelper = SnowplowHelper
